import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ExtraChargesList from './ExtraChargesList'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'

const ExtraChargesTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('extraCharges')
  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return (
    <>
      {checkPageAccess(
        pageAccess,
        allPages?.extraCharges,
        allCrudNames?.read
      ) && (
        <div className='card overflow-hidden'>
          <div className='card-body p-0'>
            <div className='nav-tabs-horizontal nav nav-tabs'>
              <Link
                onClick={(e) => handleTabClick(e, 'extraCharges')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'extraCharges' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Extra Charges
                  <hr />
                </span>
              </Link>
            </div>

            <div className='tab-content p-3'>
              <div
                id='maincategory'
                className={`tab-pane fade ${
                  activeToggle === 'extraCharges' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'extraCharges' && <ExtraChargesList />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ExtraChargesTabbing
